import React from "react";
import { BlueprintIcon } from "../blueprint-icon";
export const ArrowDownIcon = (props) => (React.createElement(BlueprintIcon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z" })));
